import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user-service';
import { environment } from '../../../environments/_active-environment/environment';

@Component({
  selector: 'app-my-rewards-widget',
  templateUrl: './my-rewards-widget.component.html',
  styleUrls: ['./my-rewards-widget.component.scss'],
  standalone: false,
})
export class MyRewardsWidgetComponent implements OnInit {
  showMyRewardsSrc: string;
  brand: string;
  myRewardsAction: string;
  userEmail: string;
  myRewardsDomainUrl: string;
  myRewardsDomainCode: number;
  companyId: number;
  companyRewardsWidgetText: string;
  hasCompanyRewardsWidgetText: Boolean = false;
  genericHTML: string;

  constructor(
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    if (
      this.userService.company.rewardsWidgetText !== null &&
      this.userService.company.rewardsWidgetText !== ''
    ) {
      this.companyRewardsWidgetText = this.userService.company.rewardsWidgetText;
      this.hasCompanyRewardsWidgetText = true;
    }
    this.brand = this.userService.brand;
    this.genericHTML = `<p>From discounted flights to weekly cinema tickets, ${this.brand} rewards you for being healthy.</p>`;
    this.showMyRewardsSrc = this.userService.getMyRewardsSpinnerSrc();
    this.myRewardsAction = this.userService.myRewardsAction;
    this.userEmail = this.userService.user.email;
    this.myRewardsDomainUrl = this.userService.myRewardsDomainUrl;
    this.myRewardsDomainCode = this.userService.myRewardsDomainCode;
    this.companyId = this.userService.company.id;
  }

  onViewRewardsClick() {
    window.open(
      `${environment.app.endpoint}/my-reward?action=${this.myRewardsAction}&email=${this.userEmail}&domain_url=${this.myRewardsDomainUrl}&domain_code=${this.myRewardsDomainCode}&company_id=${this.companyId}&registered=1`,
    );
  }
}
